import type { JSX } from 'react';
import { DrawApi } from '@apply/api';
import { DrawType } from '@apply/constants';

import React from 'react';
import { useAuthentication } from '../../../../../../../apps/bfi-apply/src/app/Login/hooks/useAuthentication';

interface ICancelButtonProps {
    draw: DrawApi.IDraw;
    onDrawDeleted: (id: number) => void;
    isReadOnly?: boolean;
}

export const CancelButton = ({ draw, onDrawDeleted, isReadOnly = false }: ICancelButtonProps): JSX.Element => {
    const { authentication } = useAuthentication();
    const isGeneralContractor = authentication?.user.isGeneralContractor ?? false;

    if (
        (draw.borrowerSubmitted && !draw.needsBorrowerSignature) ||
        draw.drawType !== DrawType.Manual ||
        draw.isFinalized ||
        (isGeneralContractor && draw.hasGeneralContractorSignature)
    )
        return <></>;

    return (
        <button
            onClick={() => onDrawDeleted(draw.id)}
            title='Cancel and delete Draw.'
            className='button primary'
            disabled={isReadOnly}
        >
            Cancel
        </button>
    );
};
